export default {
  // list
  'base_warehouse.query.name': '名称',
  'base_warehouse.query.name.placeholder': '请输入名称',
  'base_warehouse.column.name': '名称',
  'base_warehouse.column.createBy': '创建人',
  'base_warehouse.column.updateBy': '更新人',
  'base_warehouse.column.createTime': '创建时间',
  'base_warehouse.column.updateTime': '更新时间',
  // edit
  'base_warehouse.edit.title': '编辑仓库',
  'base_warehouse.add.title': '新增仓库',
  'base_warehouse.edit.success': '编辑成功',
  'base_warehouse.add.success': '新增成功',
  'base_warehouse.form.name.required': '名称不能为空',
  'base_warehouse.form.name': '名称',
  'base_warehouse.form.name.placeholder': '请输入名称',
}
